import { useParams } from "react-router-dom";

import vacancyService from "../../../services/vacancyService";
import { useBeManualFetcher } from "../../../hooks/useBeManualFetcher";
import { useVacancyPageContext } from "../../../hooks/useVacancyPageContext";
import EventEmitter, { EVENT_TOPICS } from "../../../utilities/eventUtils";
import { buildVacancyBlockRequestBody } from "../../../utilities/vacancyUtils";

// Blok o'z maydonlarini beradi, qolgani joriy ma'lumotdan olinadi.
export const useVacancyBlockSave = () => {
  const { vacancyId } = useParams();
  const [onFetch, isLoading] = useBeManualFetcher();
  const { singleVacancy, setSingleVacancy } = useVacancyPageContext();

  const save = (patch, onDone) =>
    onFetch({
      action: () =>
        vacancyService.updateVacancy(
          vacancyId,
          buildVacancyBlockRequestBody(singleVacancy, patch)
        ),
      onLoad: (updatedVacancy) => {
        setSingleVacancy((prev) => ({ ...prev, ...updatedVacancy }));
        EventEmitter.emit(EVENT_TOPICS.ON_VACANCY_UPDATED, { updatedVacancy });
        onDone?.();
      },
      successMessage: "Vacancy updated successfully",
    });

  return { save, isLoading, vacancy: singleVacancy };
};
